import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const KATEGORI_MAP: Record<string, { etiket: string; renk: string; rgb: string }> = {
  genel: { etiket: 'GENEL', renk: '#64748b', rgb: '100,116,139' },
  acil: { etiket: 'ACIL', renk: '#ef4444', rgb: '239,68,68' },
  bilgi: { etiket: 'BILGI', renk: '#06b6d4', rgb: '6,182,212' },
  hatirlatma: { etiket: 'HATIRLATMA', renk: '#eab308', rgb: '234,179,8' },
};

@Component({
  selector: 'basit-not-kart', standalone: true, imports: [CommonModule], changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--note" [style.--accent]="kategoriBilgi().renk" [style.--accent-rgb]="kategoriBilgi().rgb" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:7s;--x:15%;--y:25%"></span><span class="gc-p" style="--d:11s;--x:75%;--y:35%"></span><span class="gc-p gc-p--kucuk" style="--d:5s;--x:40%;--y:70%"></span><span class="gc-p" style="--d:9s;--x:85%;--y:15%"></span><span class="gc-p gc-p--buyuk" style="--d:13s;--x:30%;--y:85%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:60%;--y:50%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">NOT</div>
        <span class="bn-kategori">{{ kategoriBilgi().etiket }}</span>
        <div class="bn-baslik gc-baslik-ana">{{ p()?.baslik || 'Isimsiz Not' }}</div>
        @if (p()?.icerik) { <div class="bn-icerik">{{ p().icerik }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 65 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #64748b; --accent-rgb: 100,116,139; }
    .gc-icerik { padding: 12px 14px; gap: 5px; }
    .bn-kategori { font-size: 8px; font-weight: 700; letter-spacing: .12em; color: var(--accent); text-shadow: 0 0 6px rgba(var(--accent-rgb),.3); animation: badge-pulse 2s ease-in-out infinite; }
    .bn-baslik { font-size: 14px; font-weight: 800; color: var(--py-metin, #e2e8f0); line-height: 1.3; transition: text-shadow .4s; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
    .gc:hover .bn-baslik { text-shadow: 0 0 12px rgba(var(--accent-rgb),.4); }
    .bn-icerik { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.5; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
  `],
})
export class BasitNotKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  kategoriBilgi = computed(() => KATEGORI_MAP[this.p()?.kategori] || { etiket: 'GENEL', renk: '#64748b', rgb: '100,116,139' });
}
